/** Where a charge's allowed values came from. */
export enum RecommendationSource {
  /** Entered by the adjuster. */
  MANUAL = 'MANUAL',

  /** A guide value the tenant configured. */
  CONFIGURED_GUIDE = 'CONFIGURED_GUIDE',

  /** Capped by a company limit. */
  COMPANY_LIMIT = 'COMPANY_LIMIT',
}
